import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core'
import 'jsbarcode'
import { printableStyles } from '../../utils'
import { ProductMove } from 'depoto-core/src/entities'
import { TranslateService } from '@ngx-translate/core'
import { CoreService } from '../../services'

declare const JsBarcode

@Component({
  selector: 'barcode-list-print-array',
  templateUrl: 'barcode-list-print-array.component.html',
  styleUrls: ['barcode-list-print-array.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BarcodeListPrintArrayComponent implements OnInit, OnChanges {
  @ViewChild('barcode') barcode: ElementRef
  @ViewChild('printable') printableEl: ElementRef
  @Input() operations: ProductMove[]
  @Output() public result: EventEmitter<any> = new EventEmitter()
  printArray: any[] = []
  pageCount = 1
  pageSelected = 1
  startAt = 0
  barcodeTitleVisible = true
  barcodeEanVisible = true
  barcodePriceVisible = true
  barcodeWidth = false
  barcodePaddingHorizontal = 0
  barcodePaddingVertical = 0
  pageMarginTop = 0
  pageMarginLeft = 0
  oneTicket = false
  wasFailedEanAlerted = false
  loading = false

  constructor(
    private translateService: TranslateService,
    protected core: CoreService
  ) {}

  ngOnInit() {
    this.wasFailedEanAlerted = false
    this.recalculateArray()
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => this.recalculateArray(), 100)
  }

  updateStartAt(field: any): void {
    this.startAt = field.id
    this.recalculateArray()
  }

  recalculateArray(): void {
    const tmpArr: any[] = []
    let id = 0
    this.loading = true
    this.operations.forEach((op: ProductMove) => {
      if (op.isEANPrintable) {
        for (let x = 0; x < op.amount; x++) {
          tmpArr.push({
            id: id,
            val: this.getBarcodeDataUrl(op.product.ean),
            fullName: op.product.fullName,
            ean: op.product.ean,
            sellPrice: op.product.sellPrice,
          })
          id++
        }
      }
    })
    const resultArr: any[] = []
    if (this.pageSelected < 1) {
      this.pageSelected = 1
    }
    id = this.pageSelected * 39 - 39
    for (let x = 0; x < 3 * 13; x++) {
      let item: any = { id: x }
      if (x >= this.startAt && id < tmpArr.length) {
        item = tmpArr[id]
        item.id = x
        id++
      }
      resultArr.push(item)
    }
    this.printArray = resultArr
    this.pageCount = Math.ceil(tmpArr.length / 39)
    if (this.pageSelected > this.pageCount) {
      this.pageSelected = this.pageCount
    }
    this.loading = false
  }

  toggleBarcodeTitleVisible(): void {
    this.barcodeTitleVisible = !this.barcodeTitleVisible
    this.recalculateArray()
  }

  toggleBarcodeEanVisible(): void {
    this.barcodeEanVisible = !this.barcodeEanVisible
    this.recalculateArray()
  }

  toggleBarcodePriceVisible(): void {
    this.barcodePriceVisible = !this.barcodePriceVisible
    this.recalculateArray()
  }

  toggleBarcodeWidth(): void {
    this.barcodeWidth = !this.barcodeWidth
    this.recalculateArray()
  }

  toggleOneTicketMode(): void {
    this.oneTicket = !this.oneTicket
    this.barcodeWidth = this.oneTicket ? true : !this.barcodeWidth
    this.recalculateArray()
  }

  pageUp(): void {
    this.pageSelected++
    if (this.pageSelected > this.pageCount) {
      this.pageSelected = this.pageCount
    }
    this.recalculateArray()
  }

  pageDown(): void {
    this.pageSelected--
    if (this.pageSelected < 1) {
      this.pageSelected = 1
    }
    this.recalculateArray()
  }

  getBarcodeDataUrl(ean: string): string {
    if (!this.barcode?.nativeElement) {
      return ''
    }
    try {
      JsBarcode(this.barcode.nativeElement, `${ean}`, {
        lineColor: '#000',
        width: this.barcodeWidth ? 2 : 1,
        height: 25,
        displayValue: false,
      })
      return this.barcode.nativeElement.toDataURL()
    } catch (e) {
      console.warn('BarcodeListPrint::ERROR', e)
      if (!this.wasFailedEanAlerted) {
        this.wasFailedEanAlerted = true
        alert(this.translateService.instant('barcode-list-print-array.error', { ean }))
      }
      return ''
    }
  }

  confirmPreview(): void {
    const pWidth = 900
    const pHeight = 720
    const popupWin = window.open(
      '',
      'Tisk štítků',
      `toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${pWidth},height=${pHeight},top=${
        screen.height - (screen.height + pHeight) / 2
      },left=${screen.width - (screen.width + pWidth) / 2}`
    )
    popupWin.document.body.innerHTML = this.printableEl.nativeElement.innerHTML
    const styles = document.createElement('style')
    styles.innerHTML = printableStyles()
    popupWin.document.head.appendChild(styles)
    setTimeout(() => {
      popupWin.print()
    }, 400)
    setTimeout(() => {
      popupWin.close()
    }, 800)
  }
}
